<template>
  <div class="confirmOrder">
    <div
      class="driversbill-tip"
      v-if="configData.formData.payPlanType === RENT_TYPE.DYNAMICRENT"
    >
      <div>租金规则</div>
      <p v-for="(item, index) in rulesList" :key="index">
        {{ item.conditionMinValue }}≤{{ item.conditionName }} <
        {{ item.conditionMaxValue === null ? '不限' : item.conditionMaxValue }},
        租金{{ item.rent }}元/每期;
      </p>
      <div class="driversbill-tip-text">
        提示:系统默认按照最低租金创建司机账单，待账单周期结束后根据司机当期完单量满足的租金条件进行补增租金金额
      </div>
    </div>
    <!-- ../FeeConfigPopup.vue有引用 -->
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <el-form ref="otherPayFrom" :model="tableDataFrom">
      <el-form-item label="租期">
        <el-input :value="rentPeriodDesc" disabled></el-input>
      </el-form-item>
      <el-form-item label="收款期数" required style="margin-bottom: 0">
      </el-form-item>
      <div
        v-if="configData.formData.depositAmountCheckTip"
        class="deposit-amount-check-tip"
      >
        <i class="el-icon-warning-outline"></i>
        <span>{{ configData.formData.depositAmountCheckTip }}</span>
      </div>
      <el-alert title="共" type="info" :closable="false">
        <template slot="title">
          共
          <span class="a-hover-link">{{ totalCount }}</span>
          期，收款总金额
          <span class="a-hover-link">{{
            configData.formData.payPlanType === RENT_TYPE.DYNAMICRENT
              ? `${billTotalAmount}元`
              : `${format(billTotalAmount)}元`
          }}</span
          >。
        </template>
      </el-alert>

      <!-- 表格：渲染当前页数据（关键修改） -->
      <el-table
        class="add-table"
        :data="currentPageData"
        row-key="num"
        size="mini"
        max-height="5100"
      >
        <!-- 期数 -->
        <el-table-column align="center" label="期数" prop="num" width="50">
        </el-table-column>
        <!-- 收款类型 -->
        <el-table-column
          align="center"
          label="收款类型"
          v-if="hideFormItem"
          width="86"
        >
          <template>
            <el-form-item>
              <span>{{ getFreeTypeName(configData.fundType) }}</span>
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column
          prop="payItem"
          align="center"
          label="账单周期"
          width="280"
        >
          <template slot-scope="scope">
            <el-form-item
              :rules="rules.accruedCycle"
              :prop="`tableData.${scope.row.originalIndex}.accruedCycle`"
            >
              <span
                v-if="
                  configData.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE
                "
                >一次性</span
              >
              <el-date-picker
                v-else-if="showAddBtn"
                v-model="scope.row.accruedCycle"
                type="daterange"
                :clearable="false"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :key="`date-picker-${scope.row.originalIndex}-${Date.now()}`"
                @input="() => handleDateRangeChange(scope.row, scope.row.originalIndex)"
                @change="() => handleDateRangeChange(scope.row, scope.row.originalIndex)"
              />
              <span v-else>{{ scope.row.accruedCycle.join(' 至 ') }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 固定租金 可以改金额  动态租金不能改金额 -->
        <el-table-column align="center" :label="planAmountLabelname">
          <template slot-scope="scope">
            <el-form-item
              :prop="`tableData.${scope.row.originalIndex}.planAmount`"
              :rules="rules.payAmount"
              class="planAmount"
            >
              <span
                v-if="
                  configData.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE ||
                  configData.formData.depositCollectRule === DEPOSIT_COLLECT_RULE.FOLLOW_RENT ||
                  configData.formData.payPlanType === RENT_TYPE.DYNAMICRENT
                "
                >{{ scope.row.planAmount }}</span
              >
              <el-input
                v-else-if="configData.formData.fundType === FEE_CODE_MAP.YA_JIN"
                placeholder="请输入"
                v-model="scope.row.planAmount"
                v-integerNumber="{
                  min: 0,
                  max: 999999999,
                }"
                :disabled="isECommerce"
                @input="(val) => priceChange(val, scope.row.originalIndex)"
              >
              </el-input>
              <el-input
                v-else-if="configData.formData.amountAccuracy === 0"
                placeholder="请输入"
                v-model="scope.row.planAmount"
                v-integerNumber="{
                  min: 0,
                  max: 999999999,
                }"
                :disabled="isECommerce"
                @input="(val) => priceChange(val, scope.row.originalIndex)"
              >
              </el-input>
              <el-input
                v-else-if="configData.formData.amountAccuracy === 2"
                placeholder="请输入"
                v-model="scope.row.planAmount"
                v-number:money="{
                  isHideErr: true,
                }"
                :disabled="isECommerce"
                @input="(val) => priceChange(val, scope.row.originalIndex)"
              >
              </el-input>
              <el-input
                v-else
                placeholder="请输入"
                v-model="scope.row.planAmount"
                :disabled="isECommerce"
                @input="(val) => priceChange(val, scope.row.originalIndex)"
              >
              </el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column align="center" fixed="right" label="操作" width="61" v-if="showAddBtn">
          <template slot-scope="scope">
            <el-popover
              :ref="scope.row.originalIndex"
              placement="bottom"
              width="230"
              popper-class="delete-order"
            >
              <p>确定删除该账期吗?</p>
              <div
                class="delete-order-btns"
                style="text-align: right; margin: 0"
              >
                <el-button size="mini" class="cancel-btn" @click="cancel"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleDel(scope.row.originalIndex)"
                  >确定</el-button
                >
              </div>
              <el-button
                type="text"
                slot="reference"
                :disabled="!isShowDeleteBtn || isECommerce"
                >删除</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <!-- 新增：分页组件（关键） -->
      <div
        :class="{'table-pagination': true, 'table-pagination-has-border': showAddBtn}"
        v-if="showPagination">
        <el-pagination
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50]"
          :current-page.sync="pagination.currentPage"
          :page-size.sync="pagination.pageSize"
          :total="totalCount"
          :small="false"
          layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>

      <div
        class="add-periods"
        v-if="showAddBtn"
      >
        <el-button type="text" icon="el-icon-plus" @click="addButton" :disabled="isECommerce || addPeriodDisabled"
          >添加期数</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import { PAYMODE_CODE_MAP, FEE_CODE_MAP } from '@/store/dict/rentPlanDict'
import { limitMoreZero } from '@/utils/validate'
import { DEPOSIT_COLLECT_RULE, RENT_TYPE, DYNAMIC_TYPE_TEXT } from '../config.js'
import { getAccruedPlanStatistic } from '@/api/domain/orders.js'
import { mapState } from 'vuex'
import { numberUtils } from '@/utils/number'
import moment from 'moment'
import { quick } from '@/utils/ba'
import { trackClick } from '@/utils/trackReport'

export default {
  props: {
    configData: {
      type: Object,
      default: () => ({}),
    },
    tableDataFrom: {
      type: Object,
      default: () => ({
        tableData: [], // 兼容空数据传入
      }),
    },
    // 是否为商城单，商城单不允许修改
    isECommerce: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      RENT_TYPE,
      FEE_CODE_MAP,
      DEPOSIT_COLLECT_RULE,
      PAYMODE_CODE_MAP,
      rules: {
        payAmount: [
          { required: true, message: '金额不能为空', trigger: 'blur' },
          {
            validator: (_, val, callback) => {
              // 全款金额不能大于50万，其他费项仍是10万
              if (this.configData.formData.fundType === FEE_CODE_MAP.QUAN_KUAN) {
                if (numberUtils.gt(val, 500000)) {
                  callback(new Error('金额不能大于五十万'))
                  return
                }
                callback()
              } else if (numberUtils.gt(val, 100000)) {
                callback(new Error('金额不能大于十万'))
                return
              }
              callback()
            },
          },
        ],
        accruedCycle: [
          { required: true, message: '周期不能为空', trigger: 'change' },
          {
            validator: (_, value, callback) => {
              const { startTime, endTime } = this.configData.formData
              if (!value || value.length === 0 || value.some((item) => !item)) {
                return callback(new Error('周期不能为空'))
              } else if (moment(value[0]) < moment(startTime) || moment(value[1]) > moment(endTime)) {
                return callback(new Error('选择的日期范围超出合同周期范围'))
              } else {
                return callback()
              }
            },
            trigger: 'change',
          },
        ],
      },
      isAddCycle: false, // 是否点击过新增期数
      totalAmount: '',
      // 分页核心配置（新增）
      pagination: {
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页显示条数
        originPage: 1, // 旧的页码
        originPageSize: 10, // 旧的每页显示条数
      },
      totalData: [], // 存储完整数据（避免直接操作props）
      currentPageData: [],
    }
  },
  computed: {
    ...mapState({
      rentOrderFeeList: (state) => state.global.rentOrderFeeList,
    }),
    rentPeriodDesc() {
      const { startTime, endTime } = this.configData.formData
      const _startTime = startTime ? startTime.split(' ')[0] || '' : ''
      const _endTime = endTime ? endTime.split(' ')[0] || '' : ''
      return `${_startTime} 至 ${_endTime}`
    },
    // 总期数（基于完整数据）
    totalCount() {
      return this.totalData.length
    },
    // 汇总 固定租金的时候前端自己算的总金额（基于完整数据）
    billTotalAmount() {
      const {
        amountAccuracy,
        payPlanType,
        receivableTotalAmount,
        totalAmount,
      } = this.configData.formData
      const amountTotal = totalAmount || receivableTotalAmount
      // 改为基于totalData计算（而非tableDataFrom.tableData）
      if (payPlanType === RENT_TYPE.DYNAMICRENT) {
        if (!this.isAddCycle) {
          return amountTotal
        }
        const list = this.totalData.reduce((acc, item) => {
          const { accruedCycle, planAmount } = item
          if (
            Array.isArray(accruedCycle) &&
            accruedCycle.length === 2 &&
            planAmount
          ) {
            acc.push({
              startCycleDate: accruedCycle[0],
              endCycleDate: accruedCycle[1],
              planAmount,
            })
          }
          return acc
        }, [])
        if (list.length === this.totalData.length) {
          this.getSignContractData(list)
        }
        return this.totalAmount || amountTotal
      } else {
        // 固定租金：基于完整数据求和
        const total = this.totalData.reduce((prev, cur) => {
          return numberUtils.plus(prev, Number(cur.planAmount) || 0)
        }, 0)
        if (amountAccuracy === 2) {
          return total.toFixed(2)
        }
        return total
      }
    },
    isShowDeleteBtn() {
      return this.totalData.length > 1 // 基于完整数据判断
    },
    hideFormItem() {
      const { payPlanType } = this.configData.formData
      return payPlanType !== RENT_TYPE.DYNAMICRENT
    },
    planAmountLabelname() {
      const { payPlanType } = this.configData.formData
      if (payPlanType === RENT_TYPE.DYNAMICRENT) {
        return '租金金额(元)'
      }
      return '应收金额(元)'
    },
    rulesList() {
      const { payPlanType, dynamicList, dynamicType } = this.configData.formData
      if (payPlanType === RENT_TYPE.DYNAMICRENT) {
        return dynamicList.map((item) => {
          return {
            conditionMinValue: item.startValue,
            conditionName: DYNAMIC_TYPE_TEXT[dynamicType],
            conditionMaxValue: item.endValue,
            rent: item.amount,
          }
        })
      }
      return []
    },
    // 只有押金且分期，才展示添加期数按钮和删除按钮，其他费项全都不展示
    showAddBtn() {
      const { fundType, depositCollectRule } = this.configData.formData
      return (
        fundType === FEE_CODE_MAP.YA_JIN &&
        depositCollectRule === DEPOSIT_COLLECT_RULE.CUSTOM_STAGES
      )
    },
    // 非押金费项才展示分页组件
    showPagination() {
      const { fundType } = this.configData.formData
      return fundType !== FEE_CODE_MAP.YA_JIN
    },
    addPeriodDisabled() {
      return Array.isArray(this.totalData) && this.totalData.length >= 12
    },
  },
  watch: {
    // 监听props传入的tableData变化，同步到totalData（避免直接修改props）
    'tableDataFrom.tableData': {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.totalData = [...newVal] // 深拷贝，避免响应式丢失
        this.generateNum() // 重新生成期数
        this.getCurrentPageData()
      },
    },
  },
  methods: {
    format: numberUtils.format,
    // 获取收款类型名称
    getFreeTypeName(type) {
      return this.rentOrderFeeList.find((item) => item.code === type)?.name
    },

    // 监听金额变化（改为接收originalIndex，操作完整数据）
    priceChange(value, originalIndex) {
      limitMoreZero(
        value,
        (v) => {
          this.$set(this.totalData, originalIndex, {
            ...this.totalData[originalIndex],
            planAmount: v,
          })
          // 同步更新props（如果父组件需要实时获取最新数据）
          this.$set(this.tableDataFrom, 'tableData', [...this.totalData])
        },
        9,
      )
    },
    // popper弹框取消
    cancel() {
      document.body.click()
    },
    // 删除条目（改为接收originalIndex，操作完整数据）
    handleDel(originalIndex) {
      this.isAddCycle = true
      this.cancel()
      // 删除完整数据中的对应行
      this.totalData.splice(originalIndex, 1)
      // 同步更新props
      this.$set(this.tableDataFrom, 'tableData', [...this.totalData])
      // 重新生成期数
      this.generateNum()
      // 分页适配：如果当前页无数据，自动跳转到上一页
      if (this.currentPageData.length === 0 && this.pagination.currentPage > 1) {
        this.pagination.currentPage -= 1
        this.getCurrentPageData()
      }
    },
    // 生成期数（基于完整数据）
    generateNum() {
      this.totalData.forEach((item, index) => {
        item.num = index + 1 // 期数从1开始连续编号
      })
    },
    // 新增期数
    addButton() {
      const { payPlanType } = this.configData.formData
      // 校验完整数据中所有行的周期是否填写完整
      if (this.totalData.every((item) => item.accruedCycle && item.accruedCycle.length === 2)) {
        this.isAddCycle = true
        const planAmount = payPlanType === RENT_TYPE.DYNAMICRENT ? this.totalData[0]?.planAmount : ''
        // 新增行到完整数据
        this.totalData.push({
          planAmount,
          startCycleDate: '',
          endCycleDate: '',
          dueDate: '',
          accruedCycle: [],
          num: this.totalData.length + 1, // 临时期数，后续generateNum会重新编号
        })
        // 重新生成期数（确保连续）
        this.generateNum()
        // 同步更新props
        this.$set(this.tableDataFrom, 'tableData', [...this.totalData])
        // 分页适配：新增后自动跳转到最后一页
        if (this.showPagination) {
          this.pagination.currentPage = Math.ceil(this.totalData.length / this.pagination.pageSize)
        }
        this.getCurrentPageData()
      } else {
        this.$refs.otherPayFrom.validate((valid) => {
          if (!valid) {
            this.$nextTick(() => {
              const firstErrorEl = document.querySelector(
                '.add-table .el-form-item.is-error',
              )
              if (firstErrorEl) {
                firstErrorEl.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                })
              }
            })
          }
        })
      }
    },
    // 动态租金服务端算总金额
    async getSignContractData(list) {
      const { fundType, depositCollectRule, amount } = this.configData.formData
      const params = {
        accruedPlanList: list,
      }
      if (
        fundType === FEE_CODE_MAP.YA_JIN &&
        (depositCollectRule === DEPOSIT_COLLECT_RULE.CUSTOM_STAGES ||
          depositCollectRule === DEPOSIT_COLLECT_RULE.FOLLOW_RENT)
      ) {
        params.totalAmount = amount
      }
      const { code, data } = await getAccruedPlanStatistic(params)
      if (code === 1) {
        this.totalAmount = data?.totalAmount
      }
    },
    // 处理日期范围选择器变化（改为接收originalIndex）
    handleDateRangeChange(row, index) {
      // 确保日期范围正确设置到行数据中
      if (row.accruedCycle && row.accruedCycle.length === 2) {
        row.startCycleDate = row.accruedCycle[0]
        row.endCycleDate = row.accruedCycle[1]
      }

      // 标记已修改
      this.isAddCycle = true

      // 强制更新整行数据
      this.$nextTick(() => {
        // 创建新对象以确保视图更新
        const updatedRow = JSON.parse(JSON.stringify(row))
        this.$set(this.tableDataFrom.tableData, index, updatedRow)
        // 清除表单验证错误
        this.$refs.otherPayFrom.clearValidate(`tableData.${index}.accruedCycle`)
        // 重新验证该字段
        this.$refs.otherPayFrom.validateField(`tableData.${index}.accruedCycle`)
      })
    },
    validateFieldPromise(field) {
      return new Promise((resolve) => {
        this.$refs.otherPayFrom.validateField(field, (errorMessage) => {
          // errorMessage: 有值=校验失败，null=校验通过
          resolve(errorMessage)
        })
      })
    },
    //  页码变化
    async handlePageChange(pageNum) {
      const currentPageRows = this.currentPageData
      let isValid = true

      for (const row of currentPageRows) {
        const cycleValid = await this.validateFieldPromise(`tableData.${row.originalIndex}.accruedCycle`)
        const amountValid = await this.validateFieldPromise(`tableData.${row.originalIndex}.planAmount`)
        if (cycleValid || amountValid) {
          isValid = false
          break
        }
      }
      // 校验通过
      if (isValid) {
        this.pagination.currentPage = pageNum
        this.pagination.originPage = pageNum
        this.getCurrentPageData()
        // 滚动到表格顶部（优化体验）
        this.$nextTick(() => {
          const tableBody = document.querySelector('.add-table .el-table__body-wrapper')
          if (tableBody) tableBody.scrollTop = 0
        })
      } else {
        this.pagination.currentPage = this.pagination.originPage
      }
    },
    // 每页条数变化
    async handleSizeChange(pageSize) {
      quick('click', 'personal_sign_contract_account_size_change', {
        pageSize,
      })
      trackClick('personal_sign_contract_account_size_change', {
        pageSize,
      })
      const currentPageRows = this.currentPageData
      let isValid = true

      for (const row of currentPageRows) {
        const cycleValid = await this.validateFieldPromise(`tableData.${row.originalIndex}.accruedCycle`)
        const amountValid = await this.validateFieldPromise(`tableData.${row.originalIndex}.planAmount`)
        if (cycleValid || amountValid) {
          isValid = false
          break
        }
      }
      // 校验通过
      if (isValid) {
        this.pagination.pageSize = pageSize
        this.pagination.originPageSize = pageSize
        this.getCurrentPageData()
        // 滚动到表格顶部（优化体验）
        this.$nextTick(() => {
          const tableBody = document.querySelector('.add-table .el-table__body-wrapper')
          if (tableBody) tableBody.scrollTop = 0
        })
      } else {
        this.pagination.pageSize = this.pagination.originPageSize
      }
    },
    // 获取当前页数据
    getCurrentPageData() {
      // 如果是押金，展示全部数据，不进行分页展示
      if (this.configData.formData.fundType === FEE_CODE_MAP.YA_JIN) {
        this.currentPageData = this.totalData.map((item, index) => ({
          ...item,
          originalIndex: index, // 关键：保留原始数据的索引，避免操作错位
        }))
        return
      }
      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize
      const end = start + this.pagination.pageSize
      // 截取当前页数据，并添加originalIndex（绑定原始数据索引，用于表单验证/事件）
      this.currentPageData = this.totalData.slice(start, end).map((item, index) => ({
        ...item,
        originalIndex: start + index, // 关键：保留原始数据的索引，避免操作错位
      }))
    },
    // eslint-disable-next-line vue/no-unused-properties
    async returnDepositInstallmentList() {
      if (this.configData.formData.depositCollectRule !== DEPOSIT_COLLECT_RULE.CUSTOM_STAGES) {
        return []
      }
      try {
        await this.$refs.otherPayFrom.validate()
        const depositInstallmentList = this.totalData.map((item, index) => ({
          numberOfPeriods: index + 1,
          presentAmount: item.planAmount,
        }))
        return depositInstallmentList
      } catch (error) {
        return []
      }
    },
  },
}
</script>
<style lang="scss" scoped>
/* 原有样式不变，新增分页容器样式（可选） */
.table-pagination {
  padding: 16px 0;
  ::v-deep .el-pagination {
    display: inline-flex;
    align-items: center;
    .el-pagination__sizes {
      height: 32px;
      line-height: 32px;
    }
  }
}
.table-pagination-has-border {
  border-left: 1px solid #eeeef0;
  border-right: 1px solid #eeeef0;
}
.add-table ::v-deep .el-form-item {
  margin-top: 16px;
  margin-bottom: 22px;
  border: 1;
}
::v-deep .el-form-item__label {
  justify-content: flex-start !important;
}

.add-table ::v-deep td {
  padding: 0 !important;
}

.add-table {
  ::v-deep thead tr {
    background-color: #f7f8fa;
  }
  ::v-deep .el-form-item__error {
    padding-left: 15px;
  }
  .planAmount ::v-deep .el-form-item__error {
    padding-left: 0;
  }
}

::v-deep .el-alert__description {
  color: #303133;
  font-weight: 500;
}
.err {
  color: red;
}
.dueDate {
  width: 124px;
}
.total {
  margin-top: 28px;
  display: flex;
  justify-content: space-between;
  .totalItem {
    width: 31%;
    align-items: center;
    margin-bottom: 10px;
    background-color: #f7f8fa;
    padding: 10px;
    border-radius: 5px;
    .totalItemLable {
      display: block;
      width: 112px;
      margin-bottom: 8px;
    }
    .totalItemValue {
      font-weight: 500;
    }
    .addButton {
      margin-left: 10px;
    }
  }
}
.driversbill-tip {
  padding: 8px 16px;
  background-color: #ecf8ff;
  border-radius: 4px;
  border-left: 5px solid #50bfff;
  margin: 20px 0;
  div {
    font-size: 14px;
  }
  p {
    font-weight: 500;
    font-size: 14px;
  }
  .driversbill-tip-text {
    font-weight: 400;
    margin-top: 5px;
  }
}
.deposit-amount-check-tip {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 8px;
  color: #c58b2a;
  background: #fff7e8;
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  i {
    margin-right: 8px;
    font-size: 16px;
  }
}
::v-deep .el-table {
  border: none;
  border-top: 1px solid #eeeef0;
  border-left: 1px solid #eeeef0;
  border-right: 1px solid #eeeef0;
  overflow: hidden;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-top: 8px;
}
::v-deep thead {
  > tr {
    > th:nth-child(1) {
      padding-right: 0;
      div.cell {
        position: relative;
        border-right: 1px solid #eeeef0;
      }
    }
    > th:nth-child(5) {
      border-left: 1px solid #eeeef0 !important;
    }
  }
}
::v-deep tbody {
  > tr {
    > td:nth-child(5) {
      border-left: 1px solid #eeeef0 !important;
    }
  }
}
::v-deep .el-table__cell {
  padding: 12px 16px;
}
::v-deep .cell {
  padding-left: 0 !important;
  font-size: 14px;
}
.add-periods {
  padding: 12px 16px;
  border: 1px solid #eeeef0;
  border-top: none;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.a-hover-link {
  cursor: auto;
}
</style>
